import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, GraduationCap, Wrench, Building2, Users2 } from "lucide-react";
import { SERVICES } from "@/lib/content";

const ICONS = [GraduationCap, Wrench, Building2, Users2];

export default function ServicesSection({ withHeading = true }) {
  return (
    <section
      data-testid="services-section"
      className="border-t border-[var(--ri-ink)] bg-white"
    >
      {withHeading && (
        <div className="ri-container py-20 md:py-28">
          <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
            <div className="lg:col-span-7">
              <div className="overline mb-4">
                <span className="dot mr-2" /> 04 — Services
              </div>
              <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95]">
                One partner.<br />
                <span className="italic font-display-soft">Every</span> piece of your future-tech stack.
              </h2>
            </div>
            <div className="lg:col-span-5">
              <p className="text-[var(--ri-muted)] leading-relaxed">
                Workshops, lab setup, year-long programs, mentorship — billed transparently and delivered with measurable outcomes.
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="ri-container pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[var(--ri-ink)] border border-[var(--ri-ink)]">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={s.code}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.55, delay: i * 0.05 }}
                className="bg-white p-7 md:p-10 group hover:bg-[var(--ri-bg)] transition-colors"
                data-testid={`service-card-${s.code.toLowerCase().replace("/", "-")}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ri-muted)]">
                    {s.code}
                  </span>
                  <Icon size={32} strokeWidth={1.4} className="text-[var(--ri-ink)] group-hover:text-[var(--ri-orange)] transition-colors" />
                </div>
                <h3 className="font-display text-3xl md:text-4xl leading-[1.05] tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-4 text-[var(--ri-muted)] text-sm leading-relaxed">
                  {s.description}
                </p>
                <ul className="mt-6 space-y-2">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2 text-sm">
                      <span className="dot mt-1.5" />
                      {b}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/contact"
                  className="btn-link mt-6 inline-flex"
                  data-testid={`service-cta-${s.code.toLowerCase().replace("/", "-")}`}
                >
                  Discuss this service <ArrowUpRight size={12} />
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
